import * as React from 'react';

// import module
import IcRcln from '@magaele/ic_rcln';

// component
import IconC from '@svg/IconC';
import Instant from '@svg/Instant';
import CrossA from '@svg/CrossA';
import CreditCard from '@svg/CreditCard';
import TimeDiscount from '@svg/TimeDiscount';
import MemberDiscount from '@svg/MemberDiscount';

interface IIconProps {
    iconType: string;
}

const IconFC: React.FC<IIconProps> = (props) => {
    const { iconType } = props;
    const handleIconType = (icontype: string) => {
        switch (icontype) {
            case 'Confirm':
                return 'toolchoosen';
            case 'Refund':
                return 'productprice';
            case 'Voucher':
                return 'productsaferule';
            case 'Reserve':
                return 'productexpiration';
            default:
                return 'toolchoosen';
        }
    };
    switch (iconType) {
        case 'MemberDiscount':
            return (
                <MemberDiscount
                    color="#00a7e1"
                    style={{ margin: '0 5px 0 0', width: '19px', height: '19px' }}
                />
            );
        case 'TimeDiscount':
            return (
                <TimeDiscount
                    color="#00a7e1"
                    style={{ margin: '0 5px 0 0', width: '19px', height: '19px' }}
                />
            );
        case 'Nonecancel':
            // 不可取消
            return (
                <CrossA
                    color="#00a7e1"
                    style={{ margin: '0 5px 0 0', width: '19px', height: '19px' }}
                />
            );
        case 'Useable':
            // 即買即用
            return (
                <Instant
                    color="#00a7e1"
                    style={{ margin: '0 5px 0 0', width: '19px', height: '19px' }}
                />
            );
        case 'Cancel':
            // 免費取消, N天前可免費取消, 出發前可免費取消
            return (
                <IconC
                    color="#00a7e1"
                    style={{ margin: '0 5px 0 0', width: '19px', height: '19px' }}
                />
            );
        case 'Getable':
            // 即買即取票
            return (
                <CreditCard
                    color="#00a7e1"
                    style={{ margin: '0 5px 0 0', width: '19px', height: '19px' }}
                />
            );
        case 'Reserve':
        // 需自行預約
        case 'Confirm':
        // 立即確認
        case 'Refund':
        // 遊玩前幾天可退款, 遊玩前幾個小時可退款, 可退款金額比例, 可退款金額, 退款手續費
        case 'Voucher':
        // 立即發送憑證
        default:
            return (
                <IcRcln
                    name={handleIconType(iconType)}
                    style={{
                        width: '20px',
                        height: '20px',
                    }}
                    colorSetting={{ data: { more: { textColor: '#00a7e1' } } }}
                    className="svg"
                />
            );
    }
};

export default IconFC;
